import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function PackPlusExtras() {
  const consulta = [{
    x: 'No sabés cómo fijar tus honorarios',
    check: 'Guía de honorarios según zona, modalidad y especialidad'
  }, {
    x: 'No te diferenciás de otras profesionales',
    check: 'Propuesta de valor clara lista para comunicar'
  }, {
    x: 'No sabés cómo conseguir derivaciones',
    check: 'Modelos de acuerdo con médicos, obras sociales e instituciones'
  }, {
    x: 'No sabés cómo organizar tus grupos',
    check: 'Sistema de organización de grupos y horarios para talleres de postparto'
  }, {
    x: 'No tenés documentación básica',
    check: 'Contratos, consentimientos y protocolos listos para usar'
  }];
  const digital = [{
    x: 'No sabés qué publicar en redes',
    check: 'Calendario de 30 días de contenido listo para postparto'
  }, {
    x: 'No te diferenciás online',
    check: 'Perfil de Instagram optimizado para profesionales de salud'
  }, {
    x: 'No convertís seguidores en pacientes',
    check: 'Sistema para atraer y convertir desde redes sociales'
  }, {
    x: 'No sabés cómo mostrar tu trabajo',
    check: 'Guía de contenido ético y profesional desde el consultorio'
  }, {
    x: 'Sin identidad profesional digital',
    check: 'Plantillas de Stories y posts editables en Canva'
  }];
  return <section className="py-12 md:py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-154">
      <div className="max-w-6xl mx-auto" data-id="element-155">
        <div className="text-center mb-8 md:mb-16" data-id="element-156">
          <h2 className="text-2xl md:text-5xl font-bold text-navy mb-2 md:mb-4" data-id="element-157">
            ¿Qué agrega el Pack Plus™?
          </h2>
          <p className="text-base md:text-xl text-navy/70 font-serif italic max-w-2xl mx-auto" data-id="element-158">
            El sistema para profesionales que no solo quieren atender — quieren
            crecer
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-6 md:gap-12" data-id="element-159">
          {/* Consulta Organizada */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} whileHover={{
          y: -2
        }} className="bg-cream rounded-2xl md:rounded-3xl p-5 md:p-8 border border-navy/5" data-id="element-160">
            <div className="mb-6 md:mb-8 border-b border-navy/10 pb-4 md:pb-6" data-id="element-161">
              <h3 className="text-lg md:text-2xl font-bold text-navy mb-1 md:mb-2" data-id="element-162">
                TU CONSULTA DE POSTPARTO ORGANIZADA
              </h3>
              <p className="text-navy/60 font-medium italic text-xs md:text-base" data-id="element-163">
                "Todo para crear, lanzar y gestionar tu práctica privada de
                postparto"
              </p>
            </div>

            <div className="space-y-4 md:space-y-6" data-id="element-164">
              {consulta.map((item, i) => <div key={i} className="grid grid-cols-[1fr_auto_1fr] gap-2 md:gap-4 items-center" data-id="element-165">
                  <div className="flex gap-1.5 md:gap-2 text-xs md:text-sm text-navy/60" data-id="element-166">
                    <X className="w-3 h-3 md:w-4 md:h-4 text-red-400 flex-shrink-0 mt-0.5" data-id="element-167" />
                    <span className="leading-tight" data-id="element-168">{item.x}</span>
                  </div>
                  <div className="w-px h-6 md:h-8 bg-navy/10" data-id="element-169"></div>
                  <div className="flex gap-1.5 md:gap-2 text-xs md:text-sm font-medium text-navy" data-id="element-170">
                    <Check className="w-3 h-3 md:w-4 md:h-4 text-sage flex-shrink-0 mt-0.5" data-id="element-171" />
                    <span className="leading-tight" data-id="element-172">{item.check}</span>
                  </div>
                </div>)}
            </div>
          </motion.div>

          {/* Profesional Digital */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} whileHover={{
          y: -2
        }} className="bg-navy rounded-2xl md:rounded-3xl p-5 md:p-8 border border-navy-400/20 text-white shadow-xl shadow-navy/10" data-id="element-173">
            <div className="mb-6 md:mb-8 border-b border-white/10 pb-4 md:pb-6" data-id="element-174">
              <h3 className="text-lg md:text-2xl font-bold text-gold mb-1 md:mb-2" data-id="element-175">
                PROFESIONAL DIGITAL: Más Pacientes con Redes Sociales
              </h3>
              <p className="text-white/60 font-medium italic text-xs md:text-base" data-id="element-176">
                "Tu presencia digital completa para llenar tu agenda de
                postparto"
              </p>
            </div>

            <div className="space-y-4 md:space-y-6" data-id="element-177">
              {digital.map((item, i) => <div key={i} className="grid grid-cols-[1fr_auto_1fr] gap-2 md:gap-4 items-center" data-id="element-178">
                  <div className="flex gap-1.5 md:gap-2 text-xs md:text-sm text-white/50" data-id="element-179">
                    <X className="w-3 h-3 md:w-4 md:h-4 text-red-400/70 flex-shrink-0 mt-0.5" data-id="element-180" />
                    <span className="leading-tight" data-id="element-181">{item.x}</span>
                  </div>
                  <div className="w-px h-6 md:h-8 bg-white/10" data-id="element-182"></div>
                  <div className="flex gap-1.5 md:gap-2 text-xs md:text-sm font-medium text-white/90" data-id="element-183">
                    <Check className="w-3 h-3 md:w-4 md:h-4 text-gold flex-shrink-0 mt-0.5" data-id="element-184" />
                    <span className="leading-tight" data-id="element-185">{item.check}</span>
                  </div>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}